import React from "react";
import TrendGilet from "../Garments/TrendGilet";

export default function TrendGiletPage() {
  return <TrendGilet />;
}
